import React from 'react'
import FirstStep from './FirstStep'
import SecondStep from './SecondStep'
import ThirdStep from './ThirdStep'
import FourthStep from './FourthStep'

interface Props {
  activeStep: number
}

const CornSilage:React.FC<Props> = ({ activeStep }) => {

  switch(activeStep) {
    case 0:
      return <FirstStep/>
    case 1:
      return <SecondStep/>
    case 2:
      return <ThirdStep/>
    case 3:
      return <FourthStep/>
    default:
      return <></>
  }
}
export default CornSilage